import { OcelotConfig } from '@/types/ocelotConfig';

const BaseConfig: OcelotConfig = {
  search: {
    header: {
      invalid: 'Ogiltig sökning. Prova igen.',
      success: 'Sökresultat för [term]',
      noHits: 'Inga träffar för [term]',
      count: '[count] Resultat',
      error: 'Ojdå! Ett fel uppstod. Prova igen.',
    },
    noTitleText: 'Ingen titel',
    googleCustomSearch: {
      apiKey: 'AIzaSyDzPGtrEiLnkUhfqxc-4zK0xNwMHvvZVSk',
      id: '',
    },
    placeholderImage: '',
  },
  analytics: {
    brandName: '',
    google: {
      gtm: 'GTM-NNQ7462Q',
      dimensions: {
        page_id: '',
        mobile_website: '',
        categories: '',
      },
      viewId: 0,
      hostname: '',
    },
    parsely: {
      siteId: '',
    },
    avo: {
      apiKey: '',
    },
    funnelRelay: {
      customerId: '',
      scriptSource: '',
    },
    tags: [],
    jwplayer: true,
  },
  features: {
    affiliateGallery: {
      enabled: true,
      apiBaseUrl: 'https://se-affiliate-gallery.aws.aller.com',
      apiEndpoint: '/api/v2/sites/[site]/populated/',
      excludedAccessLevels: ['purchase'],
    },
    nextVideoRecommendation: {
      enabled: true,
    },
    payments: {
      v1: { purchaseTag: undefined },
      v2: {
        defaultPlan: '',
        allowedPaymentMethods: [],
        bffOAuth: {
          scope: '',
          audience: '',
        },
      },
    },
    recommendedArticles: {
      enabled: true,
      excludedAccessLevels: ['purchase'],
    },
    login: {
      v1: {
        enabled: false,
        brandName: '',
        isUserMigrationEnabled: false,
      },
      v2: { enabled: false },
    },
    infinityScrollArticle: {
      enabled: false,
      excludedAccessLevels: ['purchase'],
    },
    infinityScrollFront: {
      enabled: true,
      title: 'Mest läst',
      mode: 'front',
      excludedAccessLevels: ['purchase'],
      explicitRoute: [],
    },
    keesingGames: {
      enabled: false,
      customerId: '',
      scriptPath: '',
      stylesPath: '',
      frontPagePathname: '',
    },
    direkt: {
      enabled: false,
      id: '',
      aId: '',
      headline: '',
      description: '',
      seoTitle: '',
      seoDescription: '',
    },
    article: {
      showNewsDisclaimer: false,
      saveArticle: {
        enabled: false,
        excludedAccessLevels: [],
      },
    },
    highlightedArticles: {
      inject: true,
      exclude: {
        urls: [],
        labradorPageTypes: [],
        labradorMetaPageTypes: [],
        accessLevels: ['purchase'],
        categories: [],
      },
      position: {
        article: 'auto',
        front: 'auto',
      },
    },
    trendingMenu: {
      inject: true,
      exclude: {
        urls: [],
        labradorPageTypes: [],
        labradorMetaPageTypes: [],
        accessLevels: ['purchase'],
        categories: [],
      },
      position: {
        article: 'auto',
        front: 'auto',
      },
      label: 'Populärt: ',
      tagPrefixes: [],
    },
    direktBanner: {
      inject: false,
      exclude: {
        urls: [],
        labradorPageTypes: [],
        labradorMetaPageTypes: [],
        accessLevels: ['purchase'],
        categories: ['creative studio'],
      },
      position: {
        article: 'auto',
        front: 'auto',
      },
    },
    banner: {
      inject: false,
      exclude: {
        urls: [],
        labradorPageTypes: [],
        labradorMetaPageTypes: [],
        accessLevels: ['purchase'],
        categories: [],
      },
      position: {
        article: 'auto',
        front: 'auto',
      },
    },
    videoReels: {
      inject: false,
      scriptSrc: '',
      playlistId: '',
      exclude: {
        urls: [],
        labradorPageTypes: [],
        labradorMetaPageTypes: [],
        accessLevels: [],
        categories: [],
      },
      position: {
        article: 'auto',
        front: 'auto',
      },
    },
    newsletterSignup: {
      enabled: true,
      agillicEnabled: false,
      availableNewsletters: {},
    },
  },
  pages: {
    author: {
      enabled: true,
      headline: 'Våra skribenter',
      description: '',
      requestArticles: {
        extraQuery: '',
      },
    },
    instagram: {
      enabled: true,
    },
    video: {
      enabled: true,
    },
    '21-dagar': {
      enabled: false,
    },
    confirmation: {
      enabled: false,
    },
    direkt: {
      enabled: false,
    },
    rssPlus: {
      enabled: false,
    },
    reels: {
      enabled: true,
    },
  },
  seo: {
    schemaMarkup: {
      name: '',
      foundingDate: '',
      alternateName: [],
      sameAs: [],
      webPages: [],
      publishingPrinciples: '',
      verificationFactCheckingPolicy: '',
      correctionsPolicy: '',
      unnamedSourcesPolicy: '',
      missionCoveragePrioritesPolicy: '',
    },
    etikett: {
      minimumArticles: 5,
    },
  },
  contentBox: {
    articleTeaser: {
      fieldSettings: {
        title: {
          textSize: {
            allowCmsOverride: true,
            default: {
              desktop: 40,
              mobile: 30,
            },
            fieldFunction: 'textSize',
          },
        },
        subtitle: {
          textSize: {
            allowCmsOverride: true,
            default: {
              desktop: 20,
              mobile: 20,
            },
            fieldFunction: 'textSize',
          },
        },
      },
    },
    textTitle: {
      fieldSettings: {
        title: {
          textAlign: {
            allowCmsOverride: true,
            default: {
              desktop: 'left',
              mobile: 'left',
            },
          },
          textBackgroundColor: {
            allowCmsOverride: true,
            default: {
              desktop: '',
              mobile: '',
            },
          },
          textColor: {
            allowCmsOverride: true,
            default: {
              desktop: '',
              mobile: '',
            },
          },
          italic: {
            allowCmsOverride: true,
            default: {
              desktop: '',
              mobile: '',
            },
          },
        },
      },
    },
    textSubtitle: {
      fieldSettings: {
        subtitle: {
          textAlign: {
            allowCmsOverride: true,
            default: {
              desktop: 'left',
              mobile: 'left',
            },
          },
          textBackgroundColor: {
            allowCmsOverride: true,
            default: {
              desktop: '',
              mobile: '',
            },
          },
          textColor: {
            allowCmsOverride: true,
            default: {
              desktop: '',
              mobile: '',
            },
          },
          italic: {
            allowCmsOverride: true,
            default: {
              desktop: '',
              mobile: '',
            },
          },
        },
      },
    },
    jwVideo: {
      fieldSettings: {
        title: {
          textSize: {
            allowCmsOverride: true,
            default: {
              desktop: 40,
              mobile: 30,
            },
            fieldFunction: 'textSize',
          },
        },
      },
    },
    markup: {
      fieldSettings: {
        markup: {
          dataValue: true,
        },
      },
    },
  },
  mobileApp: {
    enabled: false,
    meta: {
      'al:android:url': '',
      'al:android:app_name': '',
      'al:android:package': '',
      'al:ios:url': '',
      'al:ios:app_store_id': '',
      'al:ios:app_name': '',
      'al:web:should_fallback': '',
    },
  },
  ads: {
    video: {
      autoPlay: '',
      clickToPlay: '',
      videoPage: '',
    },
    exceptionPaths: {},
    preload: {
      enabled: true,
    },
  },
  cmp: {
    onetrust_id: '',
    preload: {
      enabled: true,
    },
  },
  labrador: {
    helperService: 'https://se-labrador-helper-services.labrador.allermedia.io',
  },
  common: {
    redirects: [],
    format: {
      date: 'D MMMM YYYY',
      time: 'HH:mm',
      dateTime: 'D MMMM YYYY HH:mm',
    },
  },
};

export default BaseConfig;
